import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container';

const PageSkeleton = () => (
	<Container
		sx={{
			my: 8,
		}}
	>
		<Skeleton sx={{ fontSize: '12px' }} />
		<Skeleton sx={{ fontSize: '12px', mt: 1 }} />
		<Skeleton sx={{ fontSize: '12px', mt: 1 }} />
		<Skeleton variant="rounded" sx={{ mt: 2 }} height={554} />
	</Container>
);

export default PageSkeleton;
